export const GIG_NEW_TAB = '_blank';
export const GIG_SAME_TAB = '_self';
